module.exports = "addu $t5, $t0, $t0\naddu $t6, $t0, $t2\naddu $t7, $t3, $t0\naddu $t8, $t4, $t0\n"